'use strict';

angular.module('amexReconciliationApp')
  .component('allocations', {
    templateUrl: 'scripts/views/components/allocations.html',
    bindings: {
      allocations: '='
    },
    controller: function (
                          ActiveTransactionAllocationsService,
                          PreviouslyUsedAccountingFieldValuesModel,
                          ActiveTransactionModel,
                          TransactionsStatusChangeService,
                          TransactionsModel,
                          UserModel,
                          SiteConfigModel,
                          ImportCsvService,
                          PaginationModelFactory,
                          AnalyticsService,
                          MaskFormatterService,
                          ErrorMessageService,
                          TransactionSearchModel,
                          LockStatusService) {
      var self = this;
      var saveSuccessful = null;
      var validationErrors = null;
      var importFailed = null;
      var importAsync = null;
      var exportHref = null;

      var PAGE_SIZE = 10;
      var AllocationPaginationModel = PaginationModelFactory.create(PAGE_SIZE);
      AllocationPaginationModel.repaginate(self.allocations);

      self.allocationIndex = function(index) {
        return self.pageStart() + index - 1;
      };

      self.updateCurrentPage = function () {
        AllocationPaginationModel.goToPageNumber(self.currentPage());
      };

      self.$onInit = function () {
        self.activeTransaction = ActiveTransactionModel.activeTransaction();
        self.pageStart = AllocationPaginationModel.pageStart;
        self.pageEnd = AllocationPaginationModel.pageEnd;
        self.totalCount = AllocationPaginationModel.totalCount;
        self.pageSize = AllocationPaginationModel.pageSize;
        self.goToLastPage = AllocationPaginationModel.goToLastPage;
        self.currentPage = AllocationPaginationModel.pageNumber;
        self.showPagination = AllocationPaginationModel.showPagination;
        self.allocationRecordsOnCurrentPage = AllocationPaginationModel.recordsOnCurrentPage;
        self.allocationRecords = AllocationPaginationModel.records;
        self.repaginate = AllocationPaginationModel.repaginate;

        self.maskValidationErrorsCount = {value: 0};
        self.maskValidationErrorsAndNotFocusedCount = {value: 0};
        self.comboFieldFlag = {allocationIndex: 0, comboValidationId: 0};
        self.allocationsWithMaskValidationError = '';
        self.isLimitedRole = TransactionSearchModel.isLimitedRole;
        self.updateAllocationsValidity = updateAllocationsValidity;
        self.updateAllAllocationsValidity = updateAllAllocationsValidity;
        self.refreshMaskValidationErrorsCount = refreshMaskValidationErrorsCount;
        self.clearLowerComboValues = clearLowerComboValues;
        
        self.getCurrencyFormat = UserModel.getCurrencyFormat;
        
        setCleanState();
        recalculateAllocationPercentages(AllocationPaginationModel.records());
        exportHref = new URI('/api/v1/exportAllocations?')
          .query({transactionId: self.activeTransaction.id})
          .toString();
      };

      self.recalculateAllocationPercentages = recalculateAllocationPercentages;
      self.recalculatePercentage = recalculatePercentage;

      self.allocationTotal = function allocationTotal() {
        return roundAmount(sumBigArray(_.map(AllocationPaginationModel.records(), 'amount')));
      };
      
      self.isDisabledTaxAllocation = function(allocation) {
        return SiteConfigModel.isActualTaxAllocationEditDisabled() && _.isEqual(_.get(allocation, 'recordType'), 'ACTUAL_TAX');
      };

      self.isDisabledNonTaxAllocation = function (allocation) {
        var isTaxAllocation = _.includes(['ACTUAL_TAX', 'ESTIMATED_TAX'], allocation.recordType);
        var siteDisabledForNonTaxAllocations = SiteConfigModel.isNonTaxAllocationEditDisabled();
        return !isTaxAllocation && siteDisabledForNonTaxAllocations;
      };
      
      self.isImportExportDisabled = function () {
        return _.some(AllocationPaginationModel.records(), function (allocation) {
          return self.isDisabledTaxAllocation(allocation) || self.isDisabledNonTaxAllocation(allocation);
        });
      };

      self.disableAddingAllocations = function () {
        if (AllocationPaginationModel.records().length === 0) {
          return false;
        }
        return _.every(AllocationPaginationModel.records(), function (allocation) {
          return self.isDisabledTaxAllocation(allocation) || self.isDisabledNonTaxAllocation(allocation);
        });
      };

      self.showLocalCurrency = function() {
        var localCurrencyIsDefined = !_.isNil(self.activeTransaction.details.localCurrency);
        var localCurrencyHasValue = self.activeTransaction.details.localCurrency !== '';
        var localCurrencyIsDifferentFromBilledCurrency = self.activeTransaction.details.billedCurrency !== self.activeTransaction.details.localCurrency;
        return localCurrencyIsDefined && localCurrencyHasValue && localCurrencyIsDifferentFromBilledCurrency;
      };

      self.exportHref = function () {
        return exportHref;
      };

      self.import = function (file) {
        if (file === null) {
          return;
        }

        if (file.constructor === Array && file.length === 0) {
          return;
        }

        setCleanState();
        self.isLoadingFile = true;

        var transactionId = _.get(self, 'activeTransaction.id');
        var promise = ImportCsvService.import(file, transactionId);
          promise.then(unpackResponse)
              .then(function (allocations) {
                if (allocations.hasOwnProperty('message')) {
                  importAsync = true;
                } else {
                  AllocationPaginationModel.repaginate(allocations);
                  validationErrors = allocationsHaveErrors(allocations);
                  saveSuccessful = !validationErrors;
                  TransactionsModel.updateAllocations(self.activeTransaction, AllocationPaginationModel.records());
                  updateAllAllocationsValidity();
                  refreshMaskValidationErrorsCount();
                }
              })

              .catch(function () {
                importFailed = true;
              })
              .finally(function () {
                self.compositeAllocationForm.$setPristine();
                self.isLoadingFile = false;
              });
        };

        function unpackResponse(response) {
          if (response === 'Allocations are being uploaded by asynchronous thread') {
            return false;
          } else {
            return response.data;
          }
        }


      self.addAllocation = function addAllocation() {
        var allocationList = AllocationPaginationModel.records();
        allocationList.push(createBlankAllocation(allocationList));
        AllocationPaginationModel.repaginate(allocationList);
        self.compositeAllocationForm.$setDirty();
        refreshMaskValidationErrorsCount();
        self.goToLastPage();
      };

      self.deleteAllocation = function deleteAllocation(index) {
        var allocationList = AllocationPaginationModel.records();

        var adjIndex = (self.currentPage() - 1) * self.pageSize() + index;
        allocationList.splice(adjIndex, 1);
        allocationList = updateAllocationsPositions(allocationList);
        self.updateCurrentPage();
        AllocationPaginationModel.repaginate(allocationList);
        self.compositeAllocationForm.$setDirty();
        refreshMaskValidationErrorsCount();
      };

      self.canDelete = function canDelete() {
        return !self.isLocked() && AllocationPaginationModel.records().length > 1;
      };

      self.isLocked = function isLocked() {
        if(LockStatusService.isLocked(self.activeTransaction)) {
          return true;
        }

        if(LockStatusService.isPartiallyLocked(self.activeTransaction) &&
          SiteConfigModel.siteConfig().partialLockOptions.accountingLocked) {
          return true;
        }
        return false;
      };

      self.saveAllocations = function saveAllocations() {
        setCleanState();
        AnalyticsService.trackSaveAllocations();

        ActiveTransactionAllocationsService.saveAllocations(self.activeTransaction, AllocationPaginationModel.records())
          .then(function (response) {
            saveSuccessful = true;
            AllocationPaginationModel.repaginate(response);
            PreviouslyUsedAccountingFieldValuesModel.refreshPreviouslyUsedAccountingFieldValues();
            TransactionsModel.updateAllocations(self.activeTransaction, AllocationPaginationModel.records());
            refreshAllocationErrorCount();
            approveIfApprovalEnabled();
          })
          .catch(function (response) {
            saveSuccessful = false;
            if (response.status === 406) {
              AllocationPaginationModel.repaginate(response.data);
              refreshAllocationErrorCount();
            }
          })
          .then(function() {
            recalculateAllocationPercentages(AllocationPaginationModel.records());
            self.compositeAllocationForm.$setPristine();
          });
      };
      
      function approveIfApprovalEnabled() {
        if (TransactionsStatusChangeService.canBeApprovedOrSubmitted(self.activeTransaction) &&
          SiteConfigModel.approveOnReallocationEnabled()) {
          TransactionsStatusChangeService.changeStatus([self.activeTransaction]);
        }
      }

      function refreshAllocationErrorCount() {
        var allocationErrorIds = [];
        _.forEach(self.allocationRecords(), function (allocation,index) {
          if (allocation.validationErrors.length > 0) {
            allocationErrorIds.push(index + 1);
          }
        });

        if (allocationErrorIds.length > 0) {
          validationErrors = true;
          self.allocationErrorIds = _.join(_.sortedUniq(allocationErrorIds),', ');
        } else {
          validationErrors = false;
          self.allocationErrorIds = '';
        }
      }

      self.displaySaveSuccessful = function () {
        return formIsPristine() && saveSuccessful;
      };

      self.displayImportFailed = function () {
        return formIsPristine() && importFailed;
      };

      self.displayImportAsync = function () {
        return formIsPristine() && importAsync;
      };

      self.displaySaveFailureValidationErrors = function () {
        return validationErrors;
      };

      self.displayApproveLine = function () {
        return TransactionSearchModel.isAccountingManager() && SiteConfigModel.approvalSettingOnForRole();
      };

      self.disabledSave = function () {
        return formIsPristine() || self.invalidTotal() || self.invalidLine() || self.hasMaskValidationErrors();
      };

      self.disabledCancel = function () {
        return formIsPristine() && !validationErrors;
      };

      self.hasMaskValidationErrors = function () {
        return self.maskValidationErrorsCount.value !== 0;
      };

      self.hasMaskValidationErrorsOnUnfocusedFields = function () {
        return self.maskValidationErrorsAndNotFocusedCount.value !== 0;
      };

      self.truncatedPercentageTotal = function truncatedPercentageTotal() {
        var precision = 2;
        var truncatedPercentageForDisplay = truncatePercentage(totalAllocationsPercentage(),precision);

        for (precision = 3; precision < 7; precision++) {
          if (self.allocationRemainingAmount() !== 0 && truncatedPercentageForDisplay === 100) {
            truncatedPercentageForDisplay = truncatePercentage(totalAllocationsPercentage(), precision);
          } else {
            break;
          }
        }
        return truncatedPercentageForDisplay;
      };

      self.allocationRemainingAmount = function allocationRemainingAmount() {
        return self.activeTransaction.amount - self.allocationTotal();
      };

      self.allocationRemainingLocalAmount = function () {
        return self.convertFromBilledCurrencyToLocalCurrency(self.allocationRemainingAmount());
      };

      self.convertFromBilledCurrencyToLocalCurrency = function(billedAmount) {
        var conversionRate = 0;
        if (self.activeTransaction.amount !== 0) {
          conversionRate = self.activeTransaction.details.localAmount / self.activeTransaction.amount;
        }
        return roundAmount(parseFloat(billedAmount) * parseFloat(conversionRate));
      };

      self.convertFromLocalCurrencyToBilledCurrency = function(localAmount) {
        var conversionRate = 0;
        if (self.activeTransaction.details.localAmount !== 0) {
          conversionRate = self.activeTransaction.amount / self.activeTransaction.details.localAmount;
        }
        return roundAmount(parseFloat(localAmount) * parseFloat(conversionRate));
      };

      self.recalculateAmount = function recalculateAmount(allocation) {
        allocation.amount = roundAmount(parseFloat(allocation.percentage) * parseFloat(self.activeTransaction.amount) / 100);

        if (percentagesTotalHundredPercent()) {
          addRemainingAmountToLastAllocation();
        }

        if (self.showLocalCurrency()) {
          allocation.localAmount = self.convertFromBilledCurrencyToLocalCurrency(allocation.amount);
        }
      };

      self.recalculateAmountAndPercentage = function(allocation) {
        allocation.amount = self.convertFromLocalCurrencyToBilledCurrency(allocation.localAmount);
        allocation.percentage = roundPercentage(calculatePercentage(allocation.amount));
      };

      self.invalidTotal = function invalidTotal() {
        return self.allocationTotal() !== _.get(self, 'activeTransaction.amount', 0);
      };

      self.cancelReallocation = function cancelReallocation() {

        ActiveTransactionAllocationsService.fetchAllocations(self.activeTransaction)
          .then(function (response) {
            self.compositeAllocationForm.$setPristine();
            AllocationPaginationModel.repaginate(response);
            setCleanState();
            recalculateAllocationPercentages(AllocationPaginationModel.records());
          });
      };

      self.hideAddAllocationsContainer = function () {
        return self.isLocked() || TransactionSearchModel.isLimitedRole() || !AllocationPaginationModel.isLastPage();
      };

      self.invalidLine = function () {
        var zeroAmounts = _.filter(AllocationPaginationModel.records(), function (o) {
          return o.amount === 0 || o.amount === undefined;
        });

        return zeroAmounts.length > 0;
      };

      self.isDescriptionRequired = function () {

        var cardTypeCode = ActiveTransactionModel.activeTransaction().cardTypeCode;
        var cardType = _.find(SiteConfigModel.siteConfig().cardTypes, {'cardTypeCode': cardTypeCode});

        if(cardType) {
          return cardType.allocationDescriptionRequired;
        }
        return false;
      };

      self.accountingFieldSchemas = function () {
        return SiteConfigModel.getAccountingFieldSchemas();
      };

      self.fieldForSchema = function (schema, allocation) {
        var accountingFieldValue = _.find(
          allocation.accountingFieldValues,
          ['position', schema.position]
        );

        if (!accountingFieldValue) {
          accountingFieldValue = {
            position: schema.position,
            value: '',
            companyId: schema.companyId
          };

          allocation.accountingFieldValues.push(accountingFieldValue);
        }

        return accountingFieldValue;
      };

      self.amountErrorMessage = function amountErrorMessage(errors) {
        return ErrorMessageService.chooseErrorMessage(errors, {
          'required': 'allocationsAmountErrorMessages.Required',
          'currency': 'allocationsAmountErrorMessages.Currency',
          'nonZeroNumber': 'allocationsAmountErrorMessages.NonZeroNumber',
          'oppositeSigns': 'allocationsAmountErrorMessages.OppositeSignAllocations'
        });
      };

      self.percentageErrorMessage = function percentageErrorMessage(errorsPercentage, errorsAmount) {
        if (!_.isEmpty(errorsPercentage)) {
          return ErrorMessageService.chooseErrorMessage(errorsPercentage, {
            'required': 'allocationsPercentageErrorMessages.Required',
            'number': 'allocationsPercentageErrorMessages.Number'
          });
        } else {
          return ErrorMessageService.chooseErrorMessage(errorsAmount, {
            'nonZeroNumber': 'allocationsPercentageErrorMessages.NonZeroNumber'
          });
        }
      };

      function setCleanState() {
        saveSuccessful = false;
        validationErrors = false;
        importFailed = false;
        self.isLoadingFile = false;
        updateAllAllocationsValidity();
        refreshMaskValidationErrorsCount();
      }

      function sumBigArray(array) {
        var collector = new Big(0);

        var bigSum = _.reduce(array, sumIgnoringNulls, collector);
        return +bigSum;
      }

      function sumIgnoringNulls(sum, element) {
        var validNumber = element && !_.isNaN(+element);
        return validNumber ? sum.add(new Big(element)) : sum;
      }

      function roundAmount(amount) {
        return _.round(amount, 2);
      }

      function totalAllocationsPercentage() {
        var amounts = _.map(AllocationPaginationModel.records(), 'amount');
        return calculatePercentage(sumBigArray(amounts));
      }

      function percentagesTotalHundredPercent() {
        var percentageSum = _.sum(_.map(self.allocationRecords(), function(o) {return parseFloat(o.percentage);}));
        return percentageSum === 100;
      }

      function addRemainingAmountToLastAllocation() {
        var allocations = self.allocationRecords();
        allocations[allocations.length - 1 ].amount += self.allocationRemainingAmount();
        self.allocationRecords(allocations);
      }

      function formIsPristine() {
        return !!_.get(self, 'compositeAllocationForm.$pristine', true);
      }

      function truncatePercentage(percentage, precision) {
        return _.floor(percentage, precision);
      }

      function roundPercentage(percentage) {
        return _.round(percentage,2);
      }

      function calculatePercentage(amount) {
        var divisor = parseFloat(self.activeTransaction.amount);

        if (!_.isNumber(amount) || _.isNaN(amount)) {
          return;
        }

        if (divisor === 0) {
          return +(new Big(0));
        }

        return +(new Big(amount)
          .div(divisor)
          .times(100)
          .toFixed());
      }

      function recalculatePercentage(allocation) {
        allocation.percentage = roundPercentage(calculatePercentage(allocation.amount));

        if (self.showLocalCurrency()) {
          allocation.localAmount = self.convertFromBilledCurrencyToLocalCurrency(allocation.amount);
        }
      }

      function recalculateAllocationPercentages(allocations) {
        var map = _.map(allocations, function(allocation) {
          if(allocation.amount) {
            recalculatePercentage(allocation);
            if (self.showLocalCurrency()) {
              allocation.localAmount = self.convertFromBilledCurrencyToLocalCurrency(allocation.amount);
            }
          }
          return allocation;
        });
        return map;
      }

      function updateAllocationsValidity(allocationIndex, fieldPosition, invalid, isFocused) {
        var allocationList = AllocationPaginationModel.records();
        var positionIndex = _.findIndex(allocationList[allocationIndex].accountingFieldValues, ['position', fieldPosition]);
        allocationList[allocationIndex].accountingFieldValues[positionIndex].invalid = invalid;
        allocationList[allocationIndex].accountingFieldValues[positionIndex].isFocused = isFocused;
        AllocationPaginationModel.records(allocationList);
      }

      function getSchema(position) {
        var schema =  _.find(SiteConfigModel.getAccountingFieldSchemas(), {position: position});
        if(schema) {
          return schema;
        }
        return null;
      }

      function updateAllAllocationsValidity() {
        var allocationList = AllocationPaginationModel.records();

        _.forEach(allocationList, function(allocation,index) {
          _.forEach(allocation.accountingFieldValues, function (accountingFieldValue,position) {
            var value = allocationList[index].accountingFieldValues[position].value;
            var schema = getSchema(accountingFieldValue.position);
            if (schema && schema.maskPattern) {
              var validationState = MaskFormatterService.validateMask(value, schema);
              allocationList[index].accountingFieldValues[position].invalid = !validationState;
            } else {
              allocationList[index].accountingFieldValues[position].invalid = false;
            }

          });
        });
        AllocationPaginationModel.records(allocationList);
      }

      function refreshMaskValidationErrorsCount() {
        var allocationList = AllocationPaginationModel.records();
        var errorCount = 0;
        var errorAndNotFocusedCount = 0;
        var allocationsWithMaskValidationError = [];
        var comboFieldFlag = { allocationIndex: 0, validationComboId: 0};

        _.forEach(allocationList, function(allocation,index) {
          _.forEach(allocation.accountingFieldValues, function (accountingFieldValue) {
            if(accountingFieldValue.invalid) {
              errorCount += 1;
            }
            if(accountingFieldValue.invalid && !accountingFieldValue.isFocused) {
              errorAndNotFocusedCount += 1;
              allocationsWithMaskValidationError.push(index + 1);
            }
            if (accountingFieldValue.isFocused) {
              comboFieldFlag = {
                allocationIndex: index,
                validationComboId: getValidationComboId(accountingFieldValue.position)
              };
            }
          });
        });
        self.maskValidationErrorsCount.value = errorCount;
        self.maskValidationErrorsAndNotFocusedCount.value = errorAndNotFocusedCount;
        self.allocationsWithMaskValidationError = _.join(_.sortedUniq(allocationsWithMaskValidationError),', ');
        self.comboFieldFlag = comboFieldFlag;
      }

      function clearLowerComboValues(allocationIndex, fieldPosition) {
        var comboId = getValidationComboId(fieldPosition);

        if (comboId > 0) {
          var displayIndex = getDisplayIndex(fieldPosition);
          var accountingFieldValues = AllocationPaginationModel.records()[allocationIndex].accountingFieldValues;

          _.forEach(accountingFieldValues, function (accountingFieldValue) {
            var validationComboId = getValidationComboId(accountingFieldValue.position);
            var fieldDisplayIndex = getDisplayIndex(accountingFieldValue.position);
            if (comboId > 0 && validationComboId === comboId && fieldDisplayIndex > displayIndex) {
              accountingFieldValue.value = '';
            }
          });
        }
      }

      function unfocusAllFields(accountingFieldValueList) {
        return _.map(accountingFieldValueList, function (accountingFieldValue) {
          accountingFieldValue.isFocused = false;
          return accountingFieldValue;
        });
      }

      function updateAllocationsPositions(allocationList) {
        return _.forEach(allocationList, function(allocation, index) {
          allocation.position = index;
          return allocation;
        });
      }

      function allocationsHaveErrors(allocations) {
        return _.some(allocations, allocationHasError);
      }

      function allocationHasError(allocation) {
        return _.get(allocation, 'validationErrors', []).length > 0;
      }

      function getValidationComboId(position) {
        return _.get(getSchema(position),'validationComboId',0);
      }

      function getDisplayIndex(position) {
        return _.get(getSchema(position),'displayIndex',0);
      }

      function createBlankAllocation(allocationList) {
        var blankAllocation = {
          _links: {self: {href: ''}},
          description: '',
          lineApproved: false
        };

        if (_.isEmpty(allocationList)) {
          blankAllocation.accountingFieldValues = _.map(SiteConfigModel.getAccountingFieldSchemas(), function (schema) {
            return {
              position: schema.position,
              value: schema.defaultValue
            };
          });
          blankAllocation.validationErrors = [];
          blankAllocation.position = 0;
          blankAllocation.percentage = '100';
          blankAllocation.amount = self.activeTransaction.amount;
        } else {
          var previousAllocation = allocationList[allocationList.length - 1];
          var copyOfPreviousAllocationAccountingFieldValues =
            angular.copy(unfocusAllFields(previousAllocation.accountingFieldValues));
          var copyOfPreviousAllocationValidationErrors =
            angular.copy(previousAllocation.validationErrors);

          blankAllocation.accountingFieldValues = copyOfPreviousAllocationAccountingFieldValues;
          blankAllocation.validationErrors = copyOfPreviousAllocationValidationErrors;
          blankAllocation.position = previousAllocation.position + 1;
          blankAllocation.percentage = '';
          blankAllocation.amount = 0;
          blankAllocation.localAmount = 0;
        }
        return blankAllocation;
      }

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/allocations.js
// module id = 434
// module chunks = 0